import { create } from 'zustand'
import type { AppState, Screen, QuizAnswer, DnaKey, DnaProfile, Destination } from '@/types'

const LEAD_EMAIL_KEY = 'yonder_lead_email'

function readStoredEmail(): string | null {
  try {
    return localStorage.getItem(LEAD_EMAIL_KEY)
  } catch {
    return null
  }
}

export const useAppStore = create<AppState>((set) => ({
  screen: 'welcome',
  answers: [],
  dnaKey: '🎢',
  dnaProfile: null,
  selectedDestination: null,
  isLoading: false,
  leadEmail: readStoredEmail(),

  setScreen: (screen: Screen) => set({ screen }),

  addAnswer: (answer: QuizAnswer) =>
    set((state) => ({
      answers: [...state.answers.filter((a) => a.questionIndex !== answer.questionIndex), answer],
      dnaKey: answer.questionIndex === 0 ? (answer.emoji as DnaKey) : state.dnaKey,
    })),

  setDnaKey: (key: DnaKey) => set({ dnaKey: key }),

  setDnaProfile: (profile: DnaProfile) => set({ dnaProfile: profile }),

  setSelectedDestination: (dest: Destination) => set({ selectedDestination: dest }),

  setIsLoading: (loading: boolean) => set({ isLoading: loading }),

  setLeadEmail: (email: string) => {
    try {
      localStorage.setItem(LEAD_EMAIL_KEY, email)
    } catch {
      // localStorage unavailable (private mode etc) — non-fatal
    }
    set({ leadEmail: email })
  },

  resetJourney: () =>
    set({
      screen: 'welcome',
      answers: [],
      dnaKey: '🎢',
      dnaProfile: null,
      selectedDestination: null,
      isLoading: false,
    }),
}))
